import { css } from '@emotion/react';
import { colors } from '../../../theme/colors';

export const fieldsConfigContainerCss = css`
  overflow-y: scroll;
  background: ${colors.primary[0]};
  padding: 1rem;
  border-radius: 4px;
`;

export const fieldsListContainerCss = css`
  margin: 0.5rem;
  gap: 1rem;
  background: ${colors.neutral[2]};
  border-radius: 4px;
`;

export const fieldItemCss = css`
  display: grid;
  align-items: center;
  padding-inline: 0.5rem;
`;
